import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import lodash from 'lodash';

import { getAppToken, toLogin } from '@/util/native';
import { createToast } from '@/util/compUtils';
import constConfig from '@/util/constConfig';
import store from '@/store';
import { getToken, setToken } from '@/util/token';

// qs.stringify({foo: [1,2,3]}, {arrayFormat: 'brackets'}) => foo[]=1&foo[]=2&foo[]=3
// qs.stringify({foo: [1,2,3]}, {arrayFormat: 'indices'}) => foo[0]=1&foo[1]=2&foo[3]=3
// qs.stringify({foo: [1,2,3]}, {arrayFormat: 'repeat'}) => foo=1&foo=2&foo=3

// axios.defaults.baseURL = 'http://localhost:9080/api';
// axios.defaults.withCredentials = true;

const axiosService = axios.create({
  baseURL: constConfig.axiosBaseURL,
  withCredentials: constConfig.axiosWithCredentials,
  timeout: constConfig.axiosTimeout,
});

axiosService.interceptors.request.use((config) => {
  let tokenVal = getAppToken();
  const tokenH5 = getToken() || '';
  if (!lodash.isEmpty(tokenVal) && !lodash.isEqual(tokenVal, tokenH5)) {
    setToken(tokenVal);
  } else {
    tokenVal = tokenH5;
  }
  const conf = config;
  conf.headers[constConfig.tokenHeaderName] = tokenVal;
  if (conf.method === 'post') {
    Vue.prototype.$f7.preloader.show('gray');
  }
  return conf;
}, error => Promise.reject(error));

axiosService.interceptors.response.use((response) => {
  Vue.prototype.$f7.preloader.hide();
  // session expried redirect login
  const configURL = response.config.url || '';
  const url = configURL.replace(constConfig.axiosBaseURL, '');
  if (response.data.code === 600 && !constConfig.igonreErrorURL.includes(url)) {
    Vue.prototype.$f7.dialog.alert('会话超时，请重新登录', '', () => {
      store.dispatch('clearStorage');
      store.dispatch('doTimeoutLogout').then(() => {
      });
      toLogin();
    });
  }
  // common message
  const msg = `温馨提示： ${response.data.msg}`;
  if (response.data.code !== 0 && response.data.code !== 600) {
    createToast(Vue.prototype, msg);
  }
  return response;
}, (error) => {
  Vue.prototype.$f7.preloader.hide();
  let msg = '未知错误，请刷新页面或者重新登录';
  if (error.code === 'ECONNABORTED') {
    msg = `请求时间超过${constConfig.axiosTimeout / 1000}秒，已超时取消`;
  }
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        msg = '请求错误';
        break;
      case 401:
        msg = '未授权，请登录';
        break;
      case 403:
        msg = '拒绝访问';
        break;
      case 404:
        msg = `请求地址出错: ${error.response.config.url}`;
        break;
      case 408:
        msg = '请求超时';
        break;
      case 500:
        msg = '服务器内部错误';
        break;
      case 501:
        msg = '服务未实现';
        break;
      case 502:
        msg = '网关错误';
        break;
      case 503:
        msg = '服务不可用';
        break;
      case 504:
        msg = '网关超时';
        break;
      case 505:
        msg = 'HTTP版本不受支持';
        break;
      default:
    }
    createToast(Vue.prototype, msg);
  }
  return Promise.reject(error);
});

axiosService.formGet = (requestURL, jsonParams, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'get',
    url: requestURL,
    params: jsonParams || {},
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  return axiosService.request(cfg).then(res => res.data);
};

axiosService.formPost = (requestURL, postData, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'post',
    url: requestURL,
    data: postData || {},
    headers: Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, axios.defaults.headers),
    transformRequest: data => qs.stringify(data, { arrayFormat: 'repeat' }),
  });
  return axiosService.request(cfg).then(res => res.data);
};

axiosService.jsonGet = (requestURL, jsonParams, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'get',
    url: requestURL,
    params: jsonParams || {},
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  return axiosService.request(cfg).then(res => res.data);
};

axiosService.jsonPost = (requestURL, postData, config) => {
  const cfg = Object.assign(config || {}, {
    method: 'post',
    url: requestURL,
    data: postData || {},
  });
  return axiosService.request(cfg).then(res => res.data);
};

export default axiosService;



// WEBPACK FOOTER //
// ./src/util/service.js